import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 6V4h-4v2h4zM4 8v11h16V8H4zm18-2v15H2.01V6H8V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2h6z"
}), 'WorkOutlineSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/WorkOutlineSharp.js
// module id = 7305
// module chunks = 2